<template>
  <el-table-column
    prop="county.name"
    label="Megye"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.address && scope.row.address.county && scope.row.address.county.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'county.name',
  };
</script>
